import { Command, ReviewData } from '../interfaces';

/**
 * Filter based on the review. I.e treatment review is >= 4.5.
 * @param data a treatment
 * @returns ReviewData[]
 */
export const reviewFilter = <T extends ReviewData>(data: T[], keys: number[]) =>
    data.filter((element) => keys.some((key) => key <= element.selectedReview.averageRating));

export class ReviewFilterCommand implements Command {
    isAndFilter(): boolean {
        return true;
    }

    execute(data: ReviewData[], keys: number[]) {
        return reviewFilter(data, keys);
    }
}
